// JSA Non Employee Signatures Validation

// This will validate the non employee signatures for the JSA form, it will need a draft validation and a submitted validation

// Draft validation
export const validateJsaNonEmployeeSignaturesDraft = (
  jsaNonEmployeeSignaturesInfo
) => {
  const errors = [];

  // Going through each non employee signature info
  jsaNonEmployeeSignaturesInfo.forEach((nonEmployee) => {
    // For draft validation, only flag an error if the row has been partially filled
    // Empty rows are acceptable in draft mode
    const hasName =
      nonEmployee.nonEmployeeName && nonEmployee.nonEmployeeName !== "";
    const hasCompany =
      nonEmployee.nonEmployeeCompany && nonEmployee.nonEmployeeCompany !== "";
    const hasSignature =
      nonEmployee.nonEmployeeSig && nonEmployee.nonEmployeeSig !== "";

    // Only validate if the row has any data at all
    if (hasName || hasCompany || hasSignature) {
      const nonEmployeeError = {
        rowId: nonEmployee.rowId,
        errors: {
          nonEmployeeName: "",
          nonEmployeeCompany: "",
          nonEmployeeSig: "",
        },
      };

      // Checking if the non employee name is empty but other fields are filled
      if (!hasName) {
        nonEmployeeError.errors.nonEmployeeName =
          "Non employee name is required";
      }

      // Checking if the non employee company is empty but other fields are filled
      if (!hasCompany) {
        nonEmployeeError.errors.nonEmployeeCompany =
          "Non employee company is required";
      }

      if (
        nonEmployeeError.errors.nonEmployeeName ||
        nonEmployeeError.errors.nonEmployeeCompany
      ) {
        errors.push(nonEmployeeError);
      }
    }
  });

  return errors;
};

// Submitted validation
export const validateJsaNonEmployeeSignaturesSubmitted = (
  jsaNonEmployeeSignaturesInfo
) => {
  const errors = [];
  // Going through each non employee signature info
  jsaNonEmployeeSignaturesInfo.forEach((nonEmployee) => {
    // Creating a non employee signature info error object
    const nonEmployeeError = {
      rowId: nonEmployee.rowId,
      errors: {
        nonEmployeeName: "",
        nonEmployeeCompany: "",
        nonEmployeeSig: "",
      },
    };

    // Checking if the non employee name is empty
    if (!nonEmployee.nonEmployeeName || nonEmployee.nonEmployeeName === "") {
      nonEmployeeError.errors.nonEmployeeName = "Non employee name is required";
    }

    // Checking if the non employee company is empty
    if (
      !nonEmployee.nonEmployeeCompany ||
      nonEmployee.nonEmployeeCompany === ""
    ) {
      nonEmployeeError.errors.nonEmployeeCompany =
        "Non employee company is required";
    }

    // Checking if the non employee signature is empty
    if (!nonEmployee.nonEmployeeSig || nonEmployee.nonEmployeeSig === "") {
      nonEmployeeError.errors.nonEmployeeSig =
        "Non employee signature is required";
    }

    if (
      nonEmployeeError.errors.nonEmployeeName ||
      nonEmployeeError.errors.nonEmployeeCompany ||
      nonEmployeeError.errors.nonEmployeeSig
    ) {
      errors.push(nonEmployeeError);
    }
  });

  return errors;
};
